module.exports = __webpack_public_path__ + "static/media/ic_Quiz-Normal.59304550.png";